import GenericDictionaryPage from "./GenericDictionaryPage";
import { getClaimDeleteReason } from "../api/claimDeleteReason";

export default function ClaimDeleteReason() {
    return (
        <GenericDictionaryPage
            tableKey="claimDeleteReason"
            fetchData={getClaimDeleteReason}
            titleKey="genericDic:claimDeleteReason"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:claimDeleteReason").toLowerCase()
                })
            }
        /> 
    );
}
